// SYSTEM_ROUTE: /source-review
import { CompactRow, EmptyState, Pane, PrivacyChip, Stack } from '@life-os/ui';
import { redactByDefault } from '@life-os/app-core';
import { useStore } from '../app/store.js';
import { useAsync } from '../lib/useAsync.js';
import { ScreenHeader } from '../app/ScreenHeader.js';

export function SourceReviewScreen() {
  const { data, revision } = useStore();
  const sources = useAsync(() => data.repositories.source.list(), [revision]);
  const items = [...(sources.value ?? [])].sort((a, b) => b.createdAt.localeCompare(a.createdAt));

  return (
    <>
      <ScreenHeader title={<>Source Review</>} subtitle={<>Raw evidence is preserved before anything is promoted. Nothing is deleted.</>} />

      <Pane title="Preserved sources" hint={`${items.length} preserved`}>
        <Stack>
          {items.length === 0 ? (
            <EmptyState title="No sources yet">
              Everything you capture is preserved here first, before it becomes a task or note.
            </EmptyState>
          ) : (
            items.map((s) => (
              <CompactRow
                key={String(s.id)}
                title={redactByDefault(s.privacyClass) ? 'Private source — preserved' : s.rawBody}
                subtitle={`${s.origin.kind.replace(/_/g, ' ')} · ${s.reviewState} · ${s.promotedToIds.length} promotion(s)`}
                meta={<PrivacyChip value={s.privacyClass} />}
              />
            ))
          )}
        </Stack>
      </Pane>
    </>
  );
}
